export enum CatalogItemType {
  Vacancy = 2,
  Resume = 1,
}

export enum CatalogSorters {
  Age = 'age',
  Price = 'price',
  Exp = 'expirience',
  Reviews = 'reviewsCount',
  CreatedAt = 'createdAt',
  MatchedAt = 'matchedAt',
}
